var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentipedeLineup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.9 186.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.5,9.9l37.3,64.6c6.7,11.7,6.7,26.1,0,37.8L261.5,177c-2.2,3.8-5,7.1-8.3,9.9h43.6c10.3,0,19.8-5.5,24.9-14.4l37.3-64.6 c5.1-8.9,5.1-19.9,0-28.8l-37.3-64.6C316.6,5.5,307,0,296.8,0h-43.6C256.5,2.8,259.3,6.1,261.5,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,79l-37.3-64.6C238.6,5.5,229,0,218.8,0h-6.6h-16.7h-7.7h-12.5c3.3,2.8,6.1,6.1,8.3,9.9l37.3,64.6             c6.7,11.7,6.7,26.1,0,37.8L183.5,177c-2.2,3.8-5,7.1-8.3,9.9h12.5h7.7h16.7h6.6c10.3,0,19.8-5.5,24.9-14.4l37.3-64.6             C286.1,98.9,286.1,87.9,281,79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,79l-37.3-64.6C160.5,5.5,151,0,140.7,0h-6.6h-68C55.8,0,46.3,5.5,41.2,14.4L3.8,79c-5.1,8.9-5.1,19.9,0,28.8l37.3,64.6             c5.1,8.9,14.7,14.4,24.9,14.4h68h6.6c10.3,0,19.8-5.5,24.9-14.4l37.3-64.6C208.1,98.9,208.1,87.9,203,79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentipedeLineup);
export default __webpack_public_path__ + "static/media/centipede-lineup.6ba1f2603b17995a3d25271585b380ca.svg";
export { ForwardRef as ReactComponent };